// OSPROD-RT-PUSH: thin wrapper over the Web Notifications API.
// No-ops on unsupported browsers, suppresses notifications when the
// page is already focused (no info delivery improvement, just noise).

export type NotificationPermissionState = 'default' | 'granted' | 'denied' | 'unsupported'

export function getNotificationPermission(): NotificationPermissionState {
  if (typeof window === 'undefined' || !('Notification' in window)) return 'unsupported'
  return Notification.permission as NotificationPermissionState
}

export async function requestNotificationPermission(): Promise<NotificationPermissionState> {
  if (typeof window === 'undefined' || !('Notification' in window)) return 'unsupported'
  if (Notification.permission === 'granted' || Notification.permission === 'denied') {
    return Notification.permission as NotificationPermissionState
  }
  const result = await Notification.requestPermission()
  return result as NotificationPermissionState
}

export interface ShowArgs {
  title: string
  body?: string
  tag?: string
  onClick?: () => void
  suppressWhenFocused?: boolean
}

export function showBrowserNotification({ title, body, tag, onClick, suppressWhenFocused = true }: ShowArgs): void {
  if (typeof window === 'undefined' || !('Notification' in window)) return
  if (Notification.permission !== 'granted') return
  if (suppressWhenFocused && document.hasFocus()) return
  const n = new Notification(title, { body, tag })
  if (onClick) {
    n.onclick = (e) => {
      e.preventDefault()
      window.focus()
      onClick()
    }
  }
}
